export interface ProjectSummary {
  id: string;
  title: string;
  category: string;
  description: string;
  image: string;
  date: string;
}

export const projectSummaries: ProjectSummary[] = [
  {
    id: "1",
    title: "Personality-driven Hydroponics Monitoring System",
    category: "AI + Sustainability",
    description:
      "A Raspberry Pi hydroponics monitor that gives the plants a dramatic AI butler with opinions.",
    image:
      "/assets/images/projects/hydroponics-monitoring-system-hero.jpeg",
    date: "2026",
  },
  {
    id: "2",
    title: "Gizmo App Minigame Creation",
    category: "GAME MAKING WITH AI",
    description:
      "A word-based Gizmo app minigame that turns learning terms into a playful rarity and reward challenge.",
    image: "/assets/images/projects/gizmo-app-iphone-hero.png",
    date: "2026",
  },
  {
    id: "3",
    title: "Gyro-Stabilised Spoon",
    category: "Assistive Tech",
    description:
      "A tremor-stabilised spoon prototype using motion sensors and servos to help keep food steadier while eating.",
    image: "/assets/images/projects/gyro-stabilised-spoon-hero.jpg",
    date: "2026",
  },
];

export function getProjectSummary(id: string | undefined) {
  return projectSummaries.find((project) => project.id === id);
}
